import { useState } from "react";
import CapturaBoletosFisicos from "./CapturaBoletosFisicos";
import { AsignarBoletosFisicosCompra, asientosDeLaVenta, esPersonal, resumenResultados } from "utils/BoletosFisicosQuery";

/* Boletos fisicos en una venta con CUALQUIER metodo de pago (link de pago, Facilito, etc.).
   El modal guarda los codigos con este hook y, cuando la compra ya existe (tiene id),
   llama a asignar(idRegistro). La asignacion la hace el backend en orden, uno por boleto. */
export function useBoletosFisicosVenta() {
    const [codigos, setCodigos] = useState([]);
    const [secciones, setSecciones] = useState({});
    const limpiar = () => { setCodigos([]); setSecciones({}); };

    // Devuelve { ok, texto } para mostrarlo en un aviso, o null si no habia codigos
    const asignar = async (idRegistro) => {
        if (!codigos.length || !idRegistro) return null;
        const lista = codigos.map((c) => ({ codigo_barras: c, ...(secciones[c] ? { seccion: secciones[c] } : {}) }));
        limpiar();
        try {
            const r = await AsignarBoletosFisicosCompra(idRegistro, lista);
            const fallos = resumenResultados(r);
            if (r?.success && !fallos) return { ok: true, texto: `${r.asignados} boleto(s) físico(s) asignado(s) a la compra #${idRegistro}` };
            return { ok: false, texto: `Compra #${idRegistro}: ${fallos || r?.message || "no se asignaron los boletos físicos"}. Corrígelo en el detalle de la orden → Boletos físicos.` };
        } catch (_e) {
            return { ok: false, texto: `Compra #${idRegistro}: no se pudieron asignar los boletos físicos. Asígnalos desde el detalle de la orden.` };
        }
    };
    return { codigos, setCodigos, secciones, setSecciones, asignar, limpiar };
}

// Seccion plegable para el modal de venta (solo personal: admin y vendedores)
export default function SeccionFisicosVenta({ fisicos, idLector }) {
    const [abierto, setAbierto] = useState(false);
    if (!esPersonal()) return null;
    const max = asientosDeLaVenta().length || 1;
    return (
        <div className="border rounded p-2 mb-3">
            <div className="form-check form-switch m-0">
                <input className="form-check-input" type="checkbox" id={`${idLector}-sw`} checked={abierto || fisicos.codigos.length > 0}
                    onChange={(e) => { setAbierto(e.target.checked); if (!e.target.checked) fisicos.limpiar(); }} />
                <label className="form-check-label" htmlFor={`${idLector}-sw`}>
                    🎟️ Entregar boletos físicos <small className="text-muted">(opcional)</small>
                </label>
            </div>
            {(abierto || fisicos.codigos.length > 0) && (
                <div className="mt-2">
                    <CapturaBoletosFisicos max={max} codigos={fisicos.codigos} setCodigos={fisicos.setCodigos}
                        secciones={fisicos.secciones} setSecciones={fisicos.setSecciones} idLector={idLector} />
                    <small className="text-muted d-block mt-1">
                        Se asignan a los boletos de la compra apenas se genere (no se canjean). Puedes cambiarlos después en el detalle de la orden.
                    </small>
                </div>
            )}
        </div>
    );
}
